import { isAxiosError } from "axios";

export function parseError(error: unknown) {
	if (isAxiosError(error)) {
		if (error.response?.data.message) {
			return error.response?.data.message;
		}

		return "Network error";
	}

	if (error instanceof Error && "message" in error) {
		return error.message;
	}

	return undefined;
}

/** Nest BadRequest `{ message, code }` body, when present. */
export function parseErrorCode(error: unknown): string | undefined {
	if (!isAxiosError(error)) {
		return undefined;
	}
	const code = error.response?.data?.code;
	return typeof code === "string" ? code : undefined;
}
